/* elcasar-custom.js — Repuestos El Casar */

(function () {
  'use strict';

  /* ── Modal de matrículas ─────────────────────────────── */

  const modal       = document.getElementById('modal-matricula');
  const modalNombre = document.getElementById('modal-modelo-nombre');

  function openModal(nombreModelo) {
    if (!modal) return;
    if (modalNombre) modalNombre.textContent = nombreModelo;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-modal]')) {
      openModal(e.target.closest('[data-open-modal]').dataset.modelo || '');
    }
    if (e.target.closest('.matricula-modal__close')) closeModal();
    if (e.target.matches('.matricula-modal__backdrop'))  closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ── Live preview de matrícula ───────────────────────── */

  const plateInput   = document.getElementById('ec-matricula-input');
  const plateDisplay = document.getElementById('ec-plate-display');

  if (plateInput && plateDisplay) {
    plateInput.addEventListener('input', function () {
      plateDisplay.textContent = this.value.toUpperCase() || '0000 AAA';
    });
  }

  /* ── Formulario presupuesto → WhatsApp directo ───────── */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-wa-form]');
    if (!form) return;
    e.preventDefault();

    var nombre    = (form.querySelector('[name="contact[name]"]')?.value    || '').trim();
    var telefono  = (form.querySelector('[name="contact[phone]"]')?.value   || '').trim();
    var email     = (form.querySelector('[name="contact[email]"]')?.value   || '').trim();
    var matricula = (form.querySelector('[name="contact[matricula]"]')?.value || '').trim().toUpperCase();
    var mensaje   = (form.querySelector('[name="contact[body]"]')?.value    || '').trim();

    var lineas = ['🔧 *Solicitud – Repuestos El Casar*', ''];
    if (nombre)    lineas.push('👤 Nombre: '    + nombre);
    if (telefono)  lineas.push('📞 Teléfono: '  + telefono);
    if (email)     lineas.push('📧 Email: '     + email);
    if (matricula) lineas.push('🚗 Matrícula: ' + matricula);
    if (mensaje)   lineas.push('💬 Nota: '      + mensaje);
    if (!nombre && !telefono && !matricula) {
      lineas.push('(Solicitud sin datos adicionales)');
    }

    var rawPhone = (form.dataset.waPhone || '34600454017').replace(/\D/g, '');
    if (!rawPhone.startsWith('34')) rawPhone = '34' + rawPhone;

    window.open('https://wa.me/' + rawPhone + '?text=' + encodeURIComponent(lineas.join('\n')), '_blank');

    form.style.display = 'none';
    var success = form.nextElementSibling;
    if (success) success.classList.add('is-visible');
  });

  /* ── Entrance animations — Tres Pilares ────────────────── */

  (function () {
    var cards = document.querySelectorAll('.pilar-card');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('ec-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ec-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(function (c) { io.observe(c); });
  })();

  /* ── Centro highlight en strip de marcas ─────────────── */

  (function () {
    var wrap = document.querySelector('.marcas__track-wrap');
    if (!wrap) return;
    var isMobile = window.matchMedia('(max-width: 640px)');

    function update() {
      /* En móvil: logos en color completo, sin efecto spotlight */
      if (isMobile.matches) {
        wrap.querySelectorAll('.marca').forEach(function (m) {
          m.style.filter  = '';
          m.style.opacity = '';
        });
        requestAnimationFrame(update);
        return;
      }
      var wrapRect = wrap.getBoundingClientRect();
      var center   = wrapRect.left + wrapRect.width / 2;
      var zone     = wrapRect.width * 0.14;
      var marcas   = Array.prototype.slice.call(wrap.querySelectorAll('.marca'));
      /* Fase de lectura — todos los rects ANTES de escribir (evita layout thrashing) */
      var rects = marcas.map(function (m) { return m.getBoundingClientRect(); });
      /* Fase de escritura */
      marcas.forEach(function (m, i) {
        var mc   = rects[i].left + rects[i].width / 2;
        var dist = Math.abs(mc - center);
        var t    = Math.max(0, Math.min(1, 1 - dist / zone));
        t = t * t;
        m.style.filter  = 'grayscale(' + (1 - t) + ')';
        m.style.opacity = (0.15 + 0.85 * t).toFixed(2);
      });
      requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  })();

  /* ── Barra de Envío Gratuito ─────────────────────────────── */
  (function () {
    var bar     = document.getElementById('ec-shipping-bar');
    var fill    = document.getElementById('ec-shipping-bar-fill');
    var message = document.getElementById('ec-shipping-bar-msg');
    var pctEl   = document.getElementById('ec-shipping-bar-pct');
    if (!bar || !fill || !message) return;

    var THRESHOLD  = parseInt(bar.dataset.threshold, 10) || 6000;
    var firstRender = true;

    function formatEuros(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + '€';
    }

    function applyWidth(pct) {
      fill.style.width = pct + '%';
    }

    function renderBar(totalCents) {
      var pct        = Math.max(0, Math.min(100, Math.round((totalCents / THRESHOLD) * 100)));
      var isComplete = totalCents >= THRESHOLD;

      if (firstRender) {
        firstRender = false;
        if (pct > 0) {
          /* Doble rAF: el navegador pinta un frame en 0% y luego anima al valor real */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { applyWidth(pct); });
          });
        }
      } else {
        applyWidth(pct);
      }

      fill.setAttribute('aria-valuenow', pct);
      bar.classList.toggle('is-complete', isComplete);
      if (pctEl) pctEl.textContent = pct + '%';

      if (isComplete) {
        message.textContent = 'Envío gratuito en esta compra ✔';
      } else if (totalCents === 0) {
        message.innerHTML = 'Añade <span class="ec-shipping-bar__amount">'
          + formatEuros(THRESHOLD) + '</span> en productos para envío gratuito';
      } else {
        message.innerHTML = 'Te faltan <span class="ec-shipping-bar__amount">'
          + formatEuros(THRESHOLD - totalCents) + '</span> para envío gratuito';
      }
    }

    function fetchAndRender() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderBar(cart.total_price); })
        .catch(function () {});
    }

    /* PubSub del tema Dawn — se dispara al añadir/quitar del carrito */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, fetchAndRender);
    }

    /* Render inicial al cargar la página */
    fetchAndRender();
  }());

  // Panel de búsqueda por defecto (colecciones + destacados al hacer foco)
  (function () {
    var input = document.getElementById('Search-Header-Bar');
    var panel = document.getElementById('elcasar-search-default');
    if (!input || !panel) return;

    var hideTimer;

    function showPanel() {
      clearTimeout(hideTimer);
      if (!input.value.trim()) {
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
      }
    }

    function hidePanel() {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    }

    input.addEventListener('focus', showPanel);

    input.addEventListener('input', function () {
      if (this.value.trim()) {
        hidePanel();
      } else {
        showPanel();
      }
    });

    input.addEventListener('blur', function () {
      hideTimer = setTimeout(hidePanel, 180);
    });

    panel.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });
  }());

})();
